import { useNavigate } from "react-router-dom";
import { Logo } from "../Logo";

const COLS = [
  { title: "Product", links: [["How It Works", "/how-it-works"], ["Nearby Providers", "/search"], ["For Providers", "/providers"], ["Post a Request Free", "/b2/request"]] },
  { title: "Company", links: [["About Us", "/about"], ["Reviews", "/reviews"], ["Contact", "/contact"]] },
  { title: "Legal", links: [["Terms of Service", "/terms-of-service"], ["Privacy", "/privacy"], ["Provider Agreement", "/provider-agreement"], ["Safety", "/safety"], ["Community Guidelines", "/community-guidelines"]] },
];

export const PublicFooter = () => {
  const navigate = useNavigate();
  return (
    <footer data-testid="public-footer" className="bg-[#0D1B3D] text-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 pt-14 pb-24">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo light />
            <p className="text-slate-400 mt-4 max-w-xs leading-relaxed text-sm">
              Brivio helps customers and service providers connect, get quotes, and manage jobs. Free. Always.
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <button onClick={() => navigate(to)} data-testid={`footer-${label.replace(/ /g, "-").toLowerCase()}`}
                      {...(to === "/app/get-help" ? { "data-cta": "footer-post-request" } : {})}
                      className="text-sm text-slate-300 hover:text-white transition-colors">{label}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-slate-500 text-sm">© {new Date().getFullYear()} Brivio. All rights reserved.</p>
          <button onClick={() => navigate("/app")} className="text-slate-300 hover:text-white text-sm transition-colors" data-testid="footer-open-app">Open App</button>
        </div>
        <p className="text-slate-600 text-xs text-center mt-6 max-w-2xl mx-auto leading-relaxed">
          Brivio is a marketplace that helps connect customers with independent service providers. Brivio does not perform, supervise, direct, insure, or control the work. Payment is handled directly between customer and provider.
        </p>
      </div>
    </footer>
  );
};
